import { ChangeDetectorRef, Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { Blog } from "../../models/blog";
import { UntypedFormGroup, FormsModule } from "@angular/forms";
import { PARAM_CALENDAR_PATH, TYPE_LIST } from "../../constants/constants";
import { Category } from "src/app/models/category";
import { ClientsService } from "src/app/services/clients.service";
import { Clients } from "src/app/models/clients";
import { Bookings } from "src/app/models/bookings";
import { BookingsService } from "src/app/services/bookings.service";
import * as $ from "jquery";
import { formatDate, NgClass } from "@angular/common";
import { Locations } from "src/app/models/locations";
import { Employees } from "src/app/models/employees";
import { Works } from "src/app/models/works";
import * as moment from "moment";
import "moment/locale/it";
import { Supports } from "src/app/models/supports";

import { ConfirmationService, SelectItem } from "primeng/api";
import { RoomsService } from "src/app/services/rooms.service";
import { forkJoin } from "rxjs";
import { AbstractListController } from "../../common/abstract-list.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Bind } from "primeng/bind";
import { MultiSelect } from "primeng/multiselect";
import { Tooltip } from "primeng/tooltip";
import { TranslatePipe } from "@ngx-translate/core";
import { FilterPipe } from "../../pipe/filter.pipe";

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-only-calendar",
    templateUrl: "./calendar.component.html",
    styleUrl: "./calendar.component.less",
    imports: [TPipe, Bind, MultiSelect, FormsModule, NgClass, Tooltip, TranslatePipe, FilterPipe]
})
export class OnlyCalendarComponent extends AbstractListController<
  Bookings,
  any
> {
  protected bookingsService: BookingsService;
  private clientService = inject(ClientsService);
  protected confirmationService: ConfirmationService;
  private changeDetector = inject(ChangeDetectorRef);
  private roomsService = inject(RoomsService);

  events: any;
  bookings: any = [];
  booking: Bookings;
  bookingsToday: any = [];
  locations: any = [];
  location: Locations;

  employees: any = [];
  employee: Employees;
  works: any = [];
  work: Works;
  clientsCount: any;
  supports: any = [];
  support: Supports;
  roomsCount: any;
  readonly error = signal<string>(undefined);
  blogForm: UntypedFormGroup;
  readonly typeList = signal<any>(undefined);
  cities: Blog[];
  selectedCity: Blog;
  uploadError: string;
  selectedDate: Date;
  date: Date;
  selectedWorks: any[];
  categories: any = [];
  category: Category;
  roomDialog: boolean = false;
  bookingsDialog: boolean = false;
  clients: any = [];
  client: Clients;
  comuni: any = [];
  displayEvent: any;
  readonly count = signal(0);
  readonly isDragging = signal(false);
  readonly startX = signal(0);
  readonly scrollLeft = signal(0);
  readonly pageSize = signal(3);
  readonly page = signal(1);
  curdate: string;
  readonly selectedDates = signal<moment.Moment[]>([]);
  readonly searchText = signal<string>(undefined);
  readonly calendarContent = viewChild.required<ElementRef>("calendarContent");
  trackByFn(index, item) {
    return item.id;
  }
  myMonth = formatDate(new Date(), "dd/MM/yyyy", "en");
  currentDate: moment.Moment = moment();
  currentTime: string = moment().format(" MMMM YYYY");
  readonly today = signal<moment.Moment>(undefined);
  readonly velocity = signal(0);
  readonly timestamp = signal(0);
  readonly lastX = signal(0);
  readonly mychart = viewChild("mychart");
  eventId: string;
  readonly currentMonth = signal<moment.Moment>(undefined);
  readonly daysInMonth = signal<moment.Moment[]>([]);
  selectedRooms: SelectItem[] = [];
  readonly rooms = signal<any[]>([]);

  constructor() {
    const bookingsService = inject(BookingsService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      bookingsService,
      confirmationService,
      router,
      route,
      PARAM_CALENDAR_PATH
    );
    this.bookingsService = bookingsService;
    this.confirmationService = confirmationService;

    this.typeList.set(TYPE_LIST);
    this.currentMonth.set(moment());
    this.today.set(moment());
  }

  customFunction() {
    alert("Custom Function Called");
  }

  ngOnInit(): void {
    this.generateCalendar();

    this.loadRooms();
  }

  goToToday() {
    this.currentMonth.set(this.today().clone());
    this.ngOnInit();
  }

  isToday(day: moment.Moment): boolean {
    return day.isSame(this.today(), "day");
  }

  loadRooms() {
    const start = this.currentMonth()
      .clone()
      .startOf("month")
      .add(-15, "days")
      .format("YYYY-MM-DD");
    const end = this.currentMonth()
      .clone()
      .endOf("month")
      .add(15, "days")
      .format("YYYY-MM-DD");

    const paramRRooms = {
      page: 0,
      size: 10,
    };
    const paramRooms = {
      page: 0,
      size: 200,
      dateFrom: start,
      dateTo: end,
      is_booked: 1,
    };

    forkJoin({
      roomData: this.roomsService.list(paramRRooms),
      bookingData: this.bookingsService.list(paramRooms),
    }).subscribe(({ roomData, bookingData }) => {

      this.rooms.set(roomData.map((room) => {
        const bookings = bookingData
          .filter((booking) => booking.roomId === room.id)
          .map((booking) => ({
            id: booking.id,
            from: this.currentMonth().format(booking.date_from),
            to: this.currentMonth().format(booking.date_to),
            name: booking.name + " " + booking.surname,
            isBooked: booking.is_booked,
          }));

        return {
          id: room.id,
          title: room.title,
          from: room.from,
          to: room.to,
          name: room.name,
          bookings: bookings,
        };
      }));
    });
  }

  generateCalendar() {
    this.daysInMonth.set([]);
    const startOfMonth = this.currentMonth().clone().startOf("month");
    const endOfMonth = this.currentMonth().clone().endOf("month");

    for (let day = startOfMonth; day.isBefore(endOfMonth); day.add(1, "day")) {
      this.daysInMonth.update((a) => { a.push(day.clone()); return [...a]; });
    }
  }

  nextMonth() {
    this.currentMonth().add(1, "month");
    this.generateCalendar();
    this.loadRooms();
  }

  previousMonth() {
    this.currentMonth().subtract(1, "month");
    this.generateCalendar();
    this.loadRooms();
  }

  isBooked(
    room: any,
    day: moment.Moment
  ): {
    checkIn: boolean;
    checkOut: boolean;
    fullDay: boolean;
    emptyDay: boolean;
    selectedBooking: any;
    selectedClient: any;
  } {
    let checkIn = false;
    let checkOut = false;
    let fullDay = false;
    let selectedBooking;
    let selectedClient;

    room.bookings.forEach((booking) => {
      const fromDate = moment(booking.from, "YYYY-MM-DD");
      const toDate = moment(booking.to, "YYYY-MM-DD");

      if (day.isSame(fromDate, "day")) {
        checkIn = true;
        selectedBooking = booking.id;
        selectedClient = booking.name;
      }

      if (day.isSame(toDate, "day")) {
        checkOut = true;
        selectedBooking = booking.id;
        selectedClient = booking.name;
      }

      if (
        day.isBetween(fromDate, toDate, "day", "()") &&
        !day.isSame(fromDate, "day") &&
        !day.isSame(toDate, "day")
      ) {
        fullDay = true;
        selectedBooking = booking.id;
        selectedClient = booking.name;
      }
    });

    return {
      checkIn,
      checkOut,
      fullDay,
      emptyDay: !checkIn && !checkOut && !fullDay,
      selectedBooking,
      selectedClient,
    };
  }

  selectDate(room: any, day: moment.Moment) {
    const isBookedDay = this.isBooked(room, day);

    if (isBookedDay.emptyDay) {
      const isSelected = this.selectedDates().some((selected) =>
        selected.isSame(day, "day")
      );

      if (isSelected) {
        this.selectedDates.set(this.selectedDates().filter(
          (selected) => !selected.isSame(day, "day")
        ));
      } else {
        this.selectedDates.update((a) => { a.push(day); return [...a]; });
      }
    }
  }

  getFilterParams(): any {
    return {
      dateFrom: this.filter("dateFrom"),
      dateTo: this.filter("dateTo"),
    };
  }

  applyFilterParams(params: any): void {
    this.setFilter("dateFrom", params["date_from"] || "");
    this.setFilter("dateTo", params["date_to"] || "");
  }

  filterItem(item: Bookings, filters: any): boolean {
    const nameMatch =
      !filters.date ||
      item.date.toLowerCase().includes(filters.date.toLowerCase());
    const descriptionMatch =
      !filters.description ||
      item.description
        .toLowerCase()
        .includes(filters.description.toLowerCase());
    return nameMatch && descriptionMatch;
  }

  clearFilters(): void {
    this.setFilter("dateFrom", "");
    this.setFilter("dateTo", "");
  }

  startDragging(event: MouseEvent) {
    this.isDragging.set(true);
    this.startX.set(event.pageX - this.calendarContent().nativeElement.offsetLeft);
    this.scrollLeft.set(this.calendarContent().nativeElement.scrollLeft);
    this.lastX.set(event.pageX);
    this.timestamp.set(Date.now());
    this.calendarContent().nativeElement.style.cursor = "grabbing";
    event.preventDefault();
  }

  drag(event: MouseEvent) {
    if (!this.isDragging()) return;

    const x = event.pageX - this.calendarContent().nativeElement.offsetLeft;
    const deltaX = event.pageX - this.lastX();
    const now = Date.now();
    const dt = now - this.timestamp();

    this.velocity.set(deltaX / dt);
    this.timestamp.set(now);
    this.lastX.set(event.pageX);

    const walk = (x - this.startX()) * 1.5;
    this.calendarContent().nativeElement.scrollLeft = this.scrollLeft() - walk;
  }

  stopDragging() {
    if (!this.isDragging()) return;

    this.isDragging.set(false);
    this.calendarContent().nativeElement.style.cursor = "grab";

    if (Math.abs(this.velocity()) > 0.5) {
      const momentum = () => {
        if (Math.abs(this.velocity()) < 0.01) return;

        this.calendarContent().nativeElement.scrollLeft -= this.velocity() * 16;
        this.velocity.update((v) => v * (0.95));
        requestAnimationFrame(momentum);
      };

      requestAnimationFrame(momentum);
    }
  }
}
